import React from 'react';
import {Button, Checkbox, DatePicker, Input, InputNumber, message, Modal, Pagination, Progress, Select, Table, Tag} from "antd";
import Axios from "../../../utils/axios";
import PATH_URL from "../../../utils/url";

class SiteSettleManageInfo extends React.Component {
    state = {
        // 站点结算统计
        statYear: null,
        statMonth: null,
        statData: [],
        // 结算记录
        year: null,
        month: null,
        status: null,
        siteId: null,
        settleDateRange: [],
        settleDateRangeStr: [],
        settleSiteQuery: '',
        current: 1,
        pageSize: 10,
        total: 0,
        data: [],
        summary: {completedTotal: 0, dueTotal: 0, discountTotal: 0, settleTotal: 0, unSettledTotal: 0},
        selectedRowKeys: [],
        generateVisible: false,
        generateProcessing: false,
        generateProgress: 0,
        selYear: 2026,
        selMonth: 1,
        batchVisible: false,
        batchAmount: null,
        batchDiscount: null,
        batchDue: 0,
        // 全选跨页标志：全选后由 toggleSettleAll 置位，批量结算据此取全部筛选 id
        settleAllActive: false,
        // 全选模式下缓存的全部筛选记录 id
        settleAllKeys: [],
        // 单条结算弹窗
        settleOneVisible: false,
        settleOneId: null,
        settleOneDue: 0,
        settleOneDiscount: 0,
        settleOneSettle: 0,
        // 备注编辑
        remarkVisible: false,
        remarkId: null,
        remarkText: '',
        // 结算特殊说明编辑（返点设置页，写入 site_rebate 表 settle_remark）
        siteRemarkVisible: false,
        siteRemarkSiteId: null,
        siteRemarkSiteName: '',
        siteRemarkText: '',
        // 返点设置-编辑弹窗：同时编辑每台返点单价与结算特殊说明
        rebateEditVisible: false,
        rebateEditSiteId: null,
        rebateEditSiteName: '',
        rebateEditAmount: null,
        rebateEditSiteRemark: '',
        // 返点设置
        sites: [],
        rebates: [],
        rebateSiteId: null,
        rebateSiteName: '',
        rebateAmount: null,
        rebateSiteQuery: '',
        rebateFilter: '',
        rebateStatus: null,
        rebateSelectedKeys: [],
        rebateCurrent: 1,
        rebatePageSize: 10,
        // 特殊渠道
        channelYear: null,
        channelMonth: null,
        channelName: '',
        channelCurrent: 1,
        channelPageSize: 10,
        channelTotal: 0,
        channelData: [],
        channelAddVisible: false,
        // 编辑态记录 id，null 表示新增
        channelEditId: null,
        addChannelYear: 2026,
        addChannelMonth: 1,
        addChannelName: '',
        addPerCommission: null,
        addTotalCount: null,
        addTotalSettle: null,
        // 权限管理：站点结算按钮权限码
        userPermission: [],
    }

    componentDidMount() {
        this.loadUserPermission();
        this.loadSites();
        this.loadRebates();
        this.loadStatistics();
        this.initSettle();
        this.loadChannels();
    }

    loadUserPermission = () => {
        let userName = JSON.parse(window.sessionStorage.getItem("userName"));
        Axios({
            method: 'get',
            url: '/menu/getUserMenu/' + userName,
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({userPermission: res.data.data || []});
            }
        }).catch(err => console.log(err));
    }

    hasPerm = (code) => {
        return this.state.userPermission != null && this.state.userPermission.includes(code);
    }

    componentWillUnmount() {
        if (this._genTimer) {
            clearInterval(this._genTimer);
            this._genTimer = null;
        }
        if (this._pollTimer) {
            clearInterval(this._pollTimer);
            this._pollTimer = null;
        }
        this.setState = (state, callback) => {
            return
        }
    }

    pad = (n) => n < 10 ? '0' + n : '' + n;

    // 站点结算统计：加载列表（按月降序）
    loadStatistics = () => {
        Axios({
            method: 'get',
            url: PATH_URL.SITE_SETTLE_STAT_URL,
            params: {
                year: this.state.statYear,
                month: this.state.statMonth,
            }
        }).then(res => {
            if (res.data.code === 200) {
                this.setState({statData: (res.data.data) || []});
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    }

    // 站点结算统计：筛选变化
    onStatFilterChange = (key, val) => {
        this.setState({[key]: val}, () => this.loadStatistics());
    }

    // 站点结算统计：重置筛选
    resetStatFilter = () => {
        this.setState({statYear: null, statMonth: null}, () => this.loadStatistics());
    }

    loadSites = () => {
        Axios({
            method: 'get',
            url: PATH_URL.SITE_LIST_NO_PAGE_URL,
        }).then(res => {
            if (res.data.code === 200) {
                // 包含全部站点（含停用），状态列/编辑回填需用到禁用站点
                const list = (res.data.data || []).filter(x => x.siteName).map(x => ({id: x.id, siteName: x.siteName, status: x.status}));
                this.setState({sites: list});
            }
        }).catch(err => console.log(err));
    }

    loadRebates = () => {
        Axios({
            method: 'get',
            url: PATH_URL.SITE_SETTLE_LIST_REBATE_URL,
        }).then(res => {
            if (res.data.code === 200) {
                // 重新加载时清空已勾选（全选）行，避免残留勾选状态
                this.setState({rebates: res.data.data || [], rebateSelectedKeys: []});
            }
        }).catch(err => console.log(err));
    }

    // 按站点名称、状态过滤返点列表
    filteredRebates = () => {
        const {rebates, rebateFilter, rebateStatus} = this.state;
        let list = rebates || [];
        const k = (rebateFilter || '').toLowerCase();
        if (k) list = list.filter(r => (r.siteName || '').toLowerCase().indexOf(k) !== -1);
        // 状态筛选（参照站点状态：0=启用，非0=停用）
        if (rebateStatus !== null && rebateStatus !== undefined) {
            list = list.filter(r => (rebateStatus === 0) ? (r.siteStatus === 0) : (r.siteStatus !== 0));
        }
        return list;
    }

    handleRebateQuery = () => {
        this.setState({rebateFilter: (this.state.rebateSiteQuery || '').trim()});
    }

    handleRebateReset = () => {
        // 完整重置：清空"站点名称"筛选、状态下拉、站点选择与每台返点单价表单项，并重新加载返回列表
        this.setState({
            rebateSiteQuery: '', rebateFilter: '', rebateStatus: null, rebateSelectedKeys: [], rebateCurrent: 1,
            rebateSiteId: null, rebateSiteName: '', rebateAmount: null
        }, () => this.loadRebates());
    }

    onRebatePageChange = (page, pageSize) => {
        this.setState({rebateCurrent: page, rebatePageSize: pageSize});
    }

    // 结算记录：全选/取消全选（筛选条件下所有页）
    toggleSettleAll = (checked) => {
        // 选中需要跨页，需先向后端取得筛选条件下全部记录ID
        Axios({
            method: 'get',
            url: PATH_URL.SITE_SETTLE_LIST_SETTLE_IDS_URL,
            params: {
                year: this.state.year,
                month: this.state.month,
                status: this.state.status,
                siteId: this.state.siteId,
                siteName: (this.state.settleSiteQuery || '').trim() || null,
                settleDateStart: (this.state.settleDateRangeStr && this.state.settleDateRangeStr[0]) || null,
                settleDateEnd: (this.state.settleDateRangeStr && this.state.settleDateRangeStr[1]) || null,
            }
        }).then(res => {
            if (res.data.code !== 200) {
                return;
            }
            const allIds = res.data.data || [];
            this.setState(prev => {
                const has = new Set(prev.selectedRowKeys || []);
                if (checked) {
                    allIds.forEach(id => has.add(id));
                } else {
                    allIds.forEach(id => has.delete(id));
                }
                return {
                    selectedRowKeys: [...has],
                    settleAllActive: checked,
                    settleAllKeys: checked ? allIds.slice() : [],
                };
            });
        }).catch(err => console.log(err));
    }

    // 返点设置：全选/取消全选当前(过滤后)列表
    toggleRebateAll = (checked) => {
        const ids = this.filteredRebates().map(r => r.id);
        this.setState(prev => {
            const has = new Set(prev.rebateSelectedKeys || []);
            if (checked) {
                ids.forEach(id => has.add(id));
            } else {
                ids.forEach(id => has.delete(id));
            }
            return {rebateSelectedKeys: [...has]};
        });
    }

    initSettle = () => {
        Axios({
            method: 'get',
            url: PATH_URL.SITE_SETTLE_LIST_SETTLE_URL,
            params: {
                year: this.state.year,
                month: this.state.month,
                status: this.state.status,
                siteId: this.state.siteId,
                siteName: (this.state.settleSiteQuery || '').trim() || null,
                settleDateStart: (this.state.settleDateRangeStr && this.state.settleDateRangeStr[0]) || null,
                settleDateEnd: (this.state.settleDateRangeStr && this.state.settleDateRangeStr[1]) || null,
                pageNum: this.state.current,
                pageSize: this.state.pageSize,
            }
        }).then(res => {
            if (res.data.code === 200) {
                const page = res.data.data;
                // 重新加载时清空已勾选（全选）行，避免残留勾选状态
                this.setState({data: (page && page.list) || [], total: (page && page.total) || 0, selectedRowKeys: []});
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
        this.loadSummary();
    }

    loadSummary = () => {
        Axios({
            method: 'get',
            url: PATH_URL.SITE_SETTLE_SUMMARY_URL,
            params: {
                year: this.state.year,
                month: this.state.month,
                status: this.state.status,
                siteId: this.state.siteId,
                siteName: (this.state.settleSiteQuery || '').trim() || null,
                settleDateStart: (this.state.settleDateRangeStr && this.state.settleDateRangeStr[0]) || null,
                settleDateEnd: (this.state.settleDateRangeStr && this.state.settleDateRangeStr[1]) || null,
            }
        }).then(res => {
            if (res.data.code === 200) {
                const s = res.data.data || {};
                this.setState({summary: {
                    completedTotal: s.completedTotal || 0,
                    dueTotal: s.dueTotal || 0,
                    discountTotal: s.discountTotal || 0,
                    settleTotal: s.settleTotal || 0,
                    unSettledTotal: s.unSettledTotal || 0,
                }});
            }
        }).catch(err => console.log(err));
    }

    onFilterChange = (key, val) => {
        this.setState({[key]: val, current: 1}, () => this.initSettle());
    }

    resetFilter = () => {
        this.setState({year: null, month: null, status: null, siteId: null, settleDateRange: [], settleDateRangeStr: [], settleSiteQuery: '', current: 1}, () => this.initSettle());
    }

    onTableChange = (page, pageSize) => {
        this.setState({current: page, pageSize}, () => this.initSettle());
    }

    openGenerate = () => this.setState({generateVisible: true, generateProcessing: false, generateProgress: 0});

    doGenerate = () => {
        if (this.state.generateProcessing) {
            return;
        }
        this.setState({generateProcessing: true, generateProgress: 2});
        // 提交异步生成任务，轮询进度接口获取真实进度
        Axios({
            method: 'post',
            url: PATH_URL.SITE_SETTLE_ASYNC_GENERATE_URL,
            data: {year: this.state.selYear, month: this.state.selMonth},
        }).then(res => {
            if (res.data.code !== 200 || !res.data.data) {
                this.finishGenerate(false, res.data.message || '启动生成失败');
                return;
            }
            this.pollGenerateProgress(res.data.data);
        }).catch(err => {
            console.log(err);
            this.finishGenerate(false, '启动生成失败，请稍后重试');
        });
    }

    pollGenerateProgress = (taskId) => {
        if (this._pollTimer) {
            clearInterval(this._pollTimer);
        }
        this._pollTimer = setInterval(() => {
            Axios({
                method: 'get',
                url: PATH_URL.SITE_SETTLE_GENERATE_PROGRESS_URL,
                params: {taskId: taskId},
            }).then(res => {
                if (res.data.code !== 200 || !res.data.data) {
                    clearInterval(this._pollTimer);
                    this._pollTimer = null;
                    this.finishGenerate(false, '进度查询失败，请刷新列表确认');
                    return;
                }
                const p = res.data.data;
                const percent = p.status === 2 ? 100 : (p.percent != null ? p.percent : 0);
                this.setState({generateProgress: percent});
                if (p.status === 2) {
                    clearInterval(this._pollTimer);
                    this._pollTimer = null;
                    this.finishGenerate(true, '生成成功，共 ' + (p.result != null ? p.result : 0) + ' 个站点');
                } else if (p.status === 3) {
                    clearInterval(this._pollTimer);
                    this._pollTimer = null;
                    this.finishGenerate(false, p.message || '生成失败');
                }
            }).catch(err => {
                console.log(err);
                clearInterval(this._pollTimer);
                this._pollTimer = null;
                this.finishGenerate(false, '进度查询失败，请刷新列表确认');
            });
        }, 800);
    }

    finishGenerate = (success, msg) => {
        if (success) {
            message.success(msg);
            setTimeout(() => this.setState({generateVisible: false, generateProcessing: false, generateProgress: 100}, () => this.initSettle()), 400);
        } else {
            message.error(msg);
            this.setState({generateProcessing: false, generateProgress: 0});
            setTimeout(() => this.setState({generateVisible: false, generateProcessing: false}), 900);
        }
    }

    openBatch = () => {
        // 以当前勾选的记录为准（全选时 selectedRowKeys 已含全部筛选 id，取消部分后即为剩余勾选）
        const sel = (this.state.selectedRowKeys || []).slice();
        if (sel.length === 0) {
            message.warning('请先勾选需要结算的记录');
            return;
        }
        // 需结算金额由后端只统计未结算记录，避免已结算记录计入
        this.fetchSettleDue(sel, (due) => {
            this.setState({
                batchVisible: true,
                batchAmount: null,
                batchDiscount: null,
                batchDue: due,
            });
        });
    }

    // 根据 id 列表计算需结算金额合计（分批取需结算金额）
    fetchSettleDue = (ids, cb) => {
        if (!ids || ids.length === 0) {
            cb(0);
            return;
        }
        Axios({
            method: 'post',
            url: PATH_URL.SITE_SETTLE_BATCH_DUE_URL,
            data: {ids},
        }).then(res => {
            if (res.data.code === 200) {
                cb(res.data.data || 0);
            } else {
                cb(0);
            }
        }).catch(() => cb(0));
    }

    batchUnSettled = () => ((this.state.batchDue || 0) - (this.state.batchDiscount || 0) - (this.state.batchAmount || 0)).toFixed(2);

    doBatch = () => {
        if (this.state.batchDiscount === null || this.state.batchDiscount === undefined || this.state.batchDiscount === '') {
            message.warning('请填写优惠金额');
            return;
        }
        if (this.state.batchAmount === null || this.state.batchAmount === undefined || this.state.batchAmount === '') {
            message.warning('请填写实结算金额');
            return;
        }
        const ids = (this.state.selectedRowKeys || []).slice();
        if (!ids.length) {
            message.warning('请先勾选需要结算的记录');
            return;
        }
        Axios({
            method: 'post',
            url: PATH_URL.SITE_SETTLE_BATCH_URL,
            data: {
                ids,
                discountAmount: this.state.batchDiscount,
                settleAmount: this.state.batchAmount,
            },
        }).then(res => {
            if (res.data.code === 200) {
                message.success(res.data.message);
            } else {
                message.error(res.data.message);
            }
            this.setState({
                batchVisible: false, selectedRowKeys: [], settleAllActive: false, settleAllKeys: []
            }, () => this.initSettle());
        }).catch(err => console.log(err));
    }

    getRebateSiteOptions = () => {
        // 已配置返点单价的站点在新建下拉中隐藏；编辑态(当前已选中的站点)需保留展示；输入筛选由 antd optionFilterProp 负责
        const cur = this.state.rebateSiteId;
        const hasRebate = new Set((this.state.rebates || []).map(r => r.siteId));
        if (cur !== null && cur !== undefined && hasRebate.has(cur)) {
            hasRebate.delete(cur);
        }
        // 新建只提供启用站点；编辑禁用站点时需回显该站点（s.status 可能为1）
        return this.state.sites.filter(s => !hasRebate.has(s.id) && (s.status === 0 || s.id === cur));
    }

    handleSiteChange = (id) => {
        const site = this.state.sites.find(x => x.id === id);
        this.setState({rebateSiteId: id, rebateSiteName: site ? site.siteName : '', rebateAmount: null});
    }

    saveRebate = () => {
        if (!this.state.rebateSiteId) {
            message.warning('请选择站点');
            return;
        }
        if (this.state.rebateAmount === null || this.state.rebateAmount === undefined || this.state.rebateAmount === '') {
            message.warning('请填写每台返点单价');
            return;
        }
        Axios({
            method: 'post',
            url: PATH_URL.SITE_SETTLE_SAVE_REBATE_URL,
            data: {siteId: this.state.rebateSiteId, siteName: this.state.rebateSiteName, rebateAmount: this.state.rebateAmount},
        }).then(res => {
            if (res.data.code === 200) {
                message.success(res.data.message);
                this.setState({rebateSiteId: null, rebateSiteName: '', rebateAmount: null});
            } else {
                message.error(res.data.message);
            }
            this.loadRebates();
        }).catch(err => console.log(err));
    }

    delRebate = (record) => {
        Modal.confirm({
            title: '确认删除',
            content: '确定删除「' + record.siteName + '」的返点设置吗？',
            okText: '删除',
            okType: 'danger',
            cancelText: '取消',
            onOk: () => {
                Axios({
                    method: 'get',
                    url: PATH_URL.SITE_SETTLE_DELETE_REBATE_URL,
                    params: {siteId: record.siteId},
                }).then(res => {
                    if (res.data.code === 200) {
                        message.success('删除成功');
                    } else {
                        message.error(res.data.message);
                    }
                    this.loadRebates();
                }).catch(err => console.log(err));
            }
        });
    }

    editRebate = (record) => {
        // 弹窗编辑：回填站点、每台返点单价与结算特殊说明
        this.setState({
            rebateEditVisible: true,
            rebateEditSiteId: record.siteId,
            rebateEditSiteName: record.siteName,
            rebateEditAmount: record.rebateAmount,
            rebateEditSiteRemark: record.siteRemark || '',
        });
    }

    // 保存返点设置编辑弹窗：同时更新每台返点单价与结算特殊说明
    saveRebateEdit = () => {
        const {rebateEditSiteId, rebateEditSiteName, rebateEditAmount} = this.state;
        if (!rebateEditSiteId) return;
        if (rebateEditAmount === null || rebateEditAmount === undefined || rebateEditAmount === '') {
            message.warning('请填写每台返点单价');
            return;
        }
        Axios({
            method: 'post',
            url: PATH_URL.SITE_SETTLE_SAVE_REBATE_URL,
            data: {siteId: rebateEditSiteId, siteName: rebateEditSiteName, rebateAmount: rebateEditAmount},
        }).then(res => {
            if (res.data.code === 200) {
                // 单价保存成功后，再保存结算特殊说明（site_rebate.settle_remark）
                Axios({
                    method: 'get',
                    url: PATH_URL.SITE_SETTLE_UPDATE_REMARK_URL,
                    params: {siteId: rebateEditSiteId, siteRemark: this.state.rebateEditSiteRemark},
                }).then(res2 => {
                    if (res2.data.code === 200) {
                        message.success('保存成功');
                    } else {
                        message.error(res2.data.message);
                    }
                    this.setState({
                        rebateEditVisible: false, rebateEditSiteId: null, rebateEditSiteName: '',
                        rebateEditAmount: null, rebateEditSiteRemark: '',
                    }, () => {
                        this.loadRebates();
                        this.initSettle();
                    });
                }).catch(err => console.log(err));
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    }

    openRevoke = (record) => {
        Modal.confirm({
            title: '确认撤回',
            content: '确定撤回「' + record.siteName + '」' + record.settleYear + '-' + this.pad(record.settleMonth) + ' 的结算吗？撤回后该记录将重新变为未结算',
            okText: '撤回',
            okType: 'danger',
            cancelText: '取消',
            onOk: () => {
                Axios({
                    method: 'post',
                    url: PATH_URL.SITE_SETTLE_REVOKE_URL,
                    data: {id: record.id},
                }).then(res => {
                    if (res.data.code === 200) {
                        message.success(res.data.message);
                    } else {
                        message.error(res.data.message);
                    }
                    this.initSettle();
                }).catch(err => console.log(err));
            }
        });
    }

    // 站点结算统计：特殊渠道框渲染
    channelBox = (channels) => {
        if (!channels || channels.length === 0) {
            return <span style={{color: '#999'}}>-</span>;
        }
        return (
            <div style={{border: '1px solid #d9d9d9', borderRadius: 4, padding: '4px 8px', minWidth: 220, maxHeight: 140, overflowY: 'auto'}}>
                <div style={{fontSize: 12, color: '#999', marginBottom: 4}}>特殊渠道</div>
                {channels.map((c, idx) => (
                    <div key={idx} style={{display: 'flex', gap: 12, fontSize: 13, whiteSpace: 'nowrap'}}>
                        <span style={{width: 110, overflow: 'hidden', textOverflow: 'ellipsis'}}>{c.channelName}</span>
                        <span>提成 ¥{Number(c.monthlyCommission || 0).toFixed(2)}</span>
                        <span>均价 ¥{Number(c.avgPrice || 0).toFixed(2)}</span>
                    </div>
                ))}
            </div>
        );
    }

    statColumns = () => [
        {title: '年月', key: 'yearMonth', width: 100, ellipsis: true,
            render: (_, r) => r.settleYear + '-' + this.pad(r.settleMonth)},
        {title: '已完成台次', dataIndex: 'completedCount', key: 'completedCount', width: 110, ellipsis: true},
        {title: '需结算金额', dataIndex: 'dueAmount', key: 'dueAmount', width: 120, ellipsis: true, render: v => Number(v || 0).toFixed(2)},
        {title: '实结算金额', dataIndex: 'settleAmount', key: 'settleAmount', width: 120, ellipsis: true, render: v => Number(v || 0).toFixed(2)},
        {title: '优惠金额', dataIndex: 'discountAmount', key: 'discountAmount', width: 120, ellipsis: true, render: v => Number(v || 0).toFixed(2)},
        {title: '未结算金额', dataIndex: 'unsettledAmount', key: 'unsettledAmount', width: 120, ellipsis: true, render: v => Number(v || 0).toFixed(2)},
        {title: '均价', dataIndex: 'avgPrice', key: 'avgPrice', width: 100, ellipsis: true, render: v => Number(v || 0).toFixed(2)},
        {title: '特殊渠道', key: 'channels', render: (_, r) => this.channelBox(r.channels)},
    ]

    settleColumns = () => [
        {title: '站点名称', dataIndex: 'siteName', key: 'siteName', width: 180, ellipsis: true},
        {title: '月份', key: 'month', width: 110, ellipsis: true, render: (_, r) => r.settleYear + '-' + this.pad(r.settleMonth)},
        {title: '已完成台次', dataIndex: 'completedCount', key: 'completedCount', width: 110, ellipsis: true},
        {title: '返点单价(元/台)', dataIndex: 'rebateAmount', key: 'rebateAmount', width: 130, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '需结算金额', dataIndex: 'dueAmount', key: 'dueAmount', width: 120, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '优惠金额', dataIndex: 'discountAmount', key: 'discountAmount', width: 120, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '实结算金额', dataIndex: 'settleAmount', key: 'settleAmount', width: 120, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '未结算金额', key: 'unSettledAmount', width: 120, ellipsis: true,
            render: (_, r) => (((r.dueAmount || 0) - (r.discountAmount || 0) - (r.settleAmount || 0)).toFixed(2))},
        {title: '备注', dataIndex: 'remark', key: 'remark', width: 240, ellipsis: true},
        {title: '结算特殊说明', dataIndex: 'siteRemark', key: 'siteRemark', width: 240, ellipsis: true},
        {title: '结算日期', key: 'settleDate', width: 120, ellipsis: true,
            render: (_, r) => this.formatDate(r.settleDate)},
        {title: '结算状态', dataIndex: 'settleStatus', key: 'settleStatus', width: 100, ellipsis: true,
            render: v => v === 1 ? (<Tag color="green">已结算</Tag>) : (<Tag color="red">未结算</Tag>)},
        {title: '操作', key: 'action', align: 'center', width: 160, fixed: 'right',
            render: (_, r) => (
                <span>
                    {this.hasPerm('400013') && r.settleStatus === 1 ? (<a style={{marginRight: 8}} onClick={() => this.openRevoke(r)}>撤回</a>) : null}
                    {this.hasPerm('400012') && r.settleStatus === 0 ? (<a style={{marginRight: 8}} onClick={() => this.openBatchSingle(r)}>结算</a>) : null}
                    <a onClick={() => this.openRemarkEdit(r)}>编辑</a>
                </span>
            )},
    ]

    formatDate = (d) => {
        if (!d) return '-';
        const date = new Date(d);
        if (isNaN(date.getTime())) return d;
        return date.getFullYear() + '-' + this.pad(date.getMonth() + 1) + '-' + this.pad(date.getDate());
    }

    openRemarkEdit = (record) => {
        this.setState({remarkVisible: true, remarkId: record.id, remarkText: record.remark || ''});
    }

    saveRemark = () => {
        if (this.state.remarkId === null) return;
        Axios({
            method: 'post',
            url: PATH_URL.SITE_SETTLE_EDIT_REMARK_URL,
            data: {id: this.state.remarkId, remark: this.state.remarkText},
        }).then(res => {
            if (res.data.code === 200) {
                message.success(res.data.message);
            } else {
                message.error(res.data.message);
            }
            this.setState({remarkVisible: false, remarkId: null, remarkText: ''}, () => this.initSettle());
        }).catch(err => console.log(err));
    }

    // 结算特殊说明：打开编辑（返点设置页）
    openSiteRemarkEdit = (record) => {
        this.setState({
            siteRemarkVisible: true,
            siteRemarkSiteId: record.siteId,
            siteRemarkSiteName: record.siteName,
            siteRemarkText: record.siteRemark || '',
        });
    }

    // 结算特殊说明：保存（写 site 表 remarks，刷新返点设置与结算记录）
    saveSiteRemark = () => {
        if (this.state.siteRemarkSiteId === null) return;
        Axios({
            method: 'get',
            url: PATH_URL.SITE_SETTLE_UPDATE_REMARK_URL,
            params: {siteId: this.state.siteRemarkSiteId, siteRemark: this.state.siteRemarkText},
        }).then(res => {
            if (res.data.code === 200) {
                message.success(res.data.message);
                this.setState({
                    siteRemarkVisible: false, siteRemarkSiteId: null,
                    siteRemarkSiteName: '', siteRemarkText: '',
                }, () => {
                    this.loadRebates();
                    this.initSettle();
                });
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    }

    exportData = (url, ids) => {
        const isRebate = url.includes('Rebate');
        const params = {};
        if (!isRebate) {
            params.year = this.state.year;
            params.month = this.state.month;
            params.status = this.state.status;
            params.siteId = this.state.siteId;
            params.siteName = (this.state.settleSiteQuery || '').trim() || null;
            params.settleDateStart = (this.state.settleDateRangeStr && this.state.settleDateRangeStr[0]) || null;
            params.settleDateEnd = (this.state.settleDateRangeStr && this.state.settleDateRangeStr[1]) || null;
        }
        if (ids && ids.length) {
            params.ids = ids.join(',');
        }
        Axios({
            method: 'get',
            url: url,
            params: params,
            responseType: 'blob',
        }).then(res => {
            const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = url.includes('Rebate') ? '返点设置.xlsx' : '结算记录.xlsx';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            a.remove();
        }).catch(err => console.log(err));
    }

    openBatchSingle = (r) => {
        this.setState({
            settleOneVisible: true,
            settleOneId: r.id,
            settleOneDue: r.dueAmount || 0,
            settleOneDiscount: r.discountAmount || 0,
            settleOneSettle: r.settleAmount || 0,
        });
    }

    settleOneUnSettled = () => ((this.state.settleOneDue || 0) - (this.state.settleOneDiscount || 0) - (this.state.settleOneSettle || 0)).toFixed(2);

    doSettleOne = () => {
        const s = this.state;
        if (s.settleOneDiscount === null || s.settleOneDiscount === undefined || s.settleOneDiscount === '') {
            message.warning('请填写优惠金额');
            return;
        }
        if (s.settleOneSettle === null || s.settleOneSettle === undefined || s.settleOneSettle === '') {
            message.warning('请填写实结算金额');
            return;
        }
        Axios({
            method: 'post',
            url: PATH_URL.SITE_SETTLE_SETTLE_ONE_URL,
            data: {id: s.settleOneId, discountAmount: s.settleOneDiscount, settleAmount: s.settleOneSettle},
        }).then(res => {
            if (res.data.code === 200) {
                message.success(res.data.message);
            } else {
                message.error(res.data.message);
            }
            this.setState({settleOneVisible: false, selectedRowKeys: []}, () => this.initSettle());
        }).catch(err => console.log(err));
    }

    rebateColumns = () => [
        {title: '站点名称', dataIndex: 'siteName', key: 'siteName', ellipsis: true},
        {title: '结算特殊说明', dataIndex: 'siteRemark', key: 'siteRemark', ellipsis: true},
        // 状态参照站点管理站点的启用状态
        {title: '状态', key: 'siteStatus', width: 90, ellipsis: true,
            render: (_, r) => r.siteStatus === 0 ? (<Tag color="green">启用</Tag>) : (<Tag color="red">停用</Tag>)},
        {title: '每台返点单价(元)', dataIndex: 'rebateAmount', key: 'rebateAmount', width: 160, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '操作', key: 'action', align: 'center', width: 190, fixed: 'right',
            render: (_, r) => (
                <span>
                    {this.hasPerm('400014') ?
                        (<a style={{marginRight: 8}} onClick={() => this.editRebate(r)}>编辑</a>) : null}
                    {this.hasPerm('400021') ? (<a style={{marginRight: 8}} onClick={() => this.delRebate(r)}>删除</a>) : null}
                    <a onClick={() => this.openSiteRemarkEdit(r)}>说明</a>
                </span>
            )},
    ]

    // 特殊渠道：加载列表
    loadChannels = () => {
        Axios({
            method: 'get',
            url: PATH_URL.SPECIAL_CHANNEL_LIST_URL,
            params: {
                channelYear: this.state.channelYear,
                channelMonth: this.state.channelMonth,
                channelName: (this.state.channelName || '').trim() || null,
                pageNum: this.state.channelCurrent,
                pageSize: this.state.channelPageSize,
            }
        }).then(res => {
            if (res.data.code === 200) {
                const page = res.data.data;
                this.setState({channelData: (page && page.list) || [], channelTotal: (page && page.total) || 0});
            } else {
                message.error(res.data.message);
            }
        }).catch(err => console.log(err));
    }

    // 特殊渠道：筛选变化
    onChannelFilterChange = (key, val) => {
        this.setState({[key]: val, channelCurrent: 1}, () => this.loadChannels());
    }

    // 特殊渠道：重置筛选
    resetChannelFilter = () => {
        this.setState({channelYear: null, channelMonth: null, channelName: '', channelCurrent: 1}, () => this.loadChannels());
    }

    // 特殊渠道：分页变化
    onChannelPageChange = (page, pageSize) => {
        this.setState({channelCurrent: page, channelPageSize: pageSize}, () => this.loadChannels());
    }

    // 特殊渠道：新增弹窗打开
    openChannelAdd = () => {
        this.setState({
            channelAddVisible: true,
            channelEditId: null,
            addChannelYear: new Date().getFullYear(),
            addChannelMonth: new Date().getMonth() + 1,
            addChannelName: '',
            addPerCommission: null,
            addTotalCount: null,
            addTotalSettle: null,
        });
    }

    // 特殊渠道：编辑弹窗打开（回填数据）
    openChannelEdit = (record) => {
        this.setState({
            channelAddVisible: true,
            channelEditId: record.id,
            addChannelYear: record.channelYear,
            addChannelMonth: record.channelMonth,
            addChannelName: record.channelName,
            addPerCommission: record.perCommission,
            addTotalCount: record.totalCount,
            addTotalSettle: record.totalSettleAmount,
        });
    }

    // 特殊渠道：当月均价（自动 = 当月结算总金额 / 当月总台次）
    addAvgPrice = () => {
        const {addTotalCount, addTotalSettle} = this.state;
        if (addTotalCount && Number(addTotalCount) > 0) {
            return (Number(addTotalSettle || 0) / Number(addTotalCount)).toFixed(2);
        }
        return '0.00';
    }

    // 特殊渠道：当月提成（自动 = 当月总台次 * 单台提成金额）
    addMonthlyCommission = () => {
        const {addTotalCount, addPerCommission} = this.state;
        return (Number(addTotalCount || 0) * Number(addPerCommission || 0)).toFixed(2);
    }

    // 特殊渠道：当月实际收入（自动 = 当月总台次 * (当月均价 - 单台提成金额)）
    addActualIncome = () => {
        const {addTotalCount, addPerCommission} = this.state;
        const avg = Number(this.addAvgPrice());
        return (Number(addTotalCount || 0) * (avg - Number(addPerCommission || 0))).toFixed(2);
    }

    // 特殊渠道：提交新增/编辑
    doChannelAdd = () => {
        const s = this.state;
        if (s.addChannelYear == null || s.addChannelMonth == null) {
            message.warning('请选择年月');
            return;
        }
        if (!s.addChannelName || !s.addChannelName.trim()) {
            message.warning('请填写渠道名称');
            return;
        }
        if (s.addPerCommission === null || s.addPerCommission === undefined || s.addPerCommission === '') {
            message.warning('请填写单台提成金额');
            return;
        }
        if (s.addTotalCount === null || s.addTotalCount === undefined || s.addTotalCount === '') {
            message.warning('请填写当月总台次');
            return;
        }
        if (s.addTotalSettle === null || s.addTotalSettle === undefined || s.addTotalSettle === '') {
            message.warning('请填写当月结算总金额');
            return;
        }
        const isEdit = s.channelEditId != null;
        const body = {
            channelYear: s.addChannelYear,
            channelMonth: s.addChannelMonth,
            channelName: s.addChannelName.trim(),
            perCommission: s.addPerCommission,
            totalCount: s.addTotalCount,
            totalSettleAmount: s.addTotalSettle,
        };
        if (isEdit) body.id = s.channelEditId;
        Axios({
            method: 'post',
            url: isEdit ? PATH_URL.SPECIAL_CHANNEL_UPDATE_URL : PATH_URL.SPECIAL_CHANNEL_ADD_URL,
            data: body,
        }).then(res => {
            if (res.data.code === 200) {
                message.success(res.data.message);
            } else {
                message.error(res.data.message);
            }
            this.setState({channelAddVisible: false}, () => this.loadChannels());
        }).catch(err => console.log(err));
    }

    // 特殊渠道：删除
    delChannel = (record) => {
        Modal.confirm({
            title: '确认删除',
            content: '确定删除「' + record.channelName + '」' + record.channelYear + '-' + this.pad(record.channelMonth) + ' 的渠道记录吗？',
            okText: '删除',
            okType: 'danger',
            cancelText: '取消',
            onOk: () => {
                Axios({
                    method: 'post',
                    url: PATH_URL.SPECIAL_CHANNEL_DELETE_URL,
                    data: {id: record.id},
                }).then(res => {
                    if (res.data.code === 200) {
                        message.success(res.data.message);
                    } else {
                        message.error(res.data.message);
                    }
                    this.loadChannels();
                }).catch(err => console.log(err));
            }
        });
    }

    channelColumns = () => [
        {title: '月份', key: 'month', width: 110, ellipsis: true,
            render: (_, r) => r.channelYear + '-' + this.pad(r.channelMonth)},
        {title: '渠道名称', dataIndex: 'channelName', key: 'channelName', width: 180, ellipsis: true},
        {title: '单台提成金额', dataIndex: 'perCommission', key: 'perCommission', width: 130, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '当月总台次', dataIndex: 'totalCount', key: 'totalCount', width: 110, ellipsis: true},
        {title: '当月结算总金额', dataIndex: 'totalSettleAmount', key: 'totalSettleAmount', width: 140, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '当月提成', dataIndex: 'monthlyCommission', key: 'monthlyCommission', width: 120, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '当月均价', dataIndex: 'avgPrice', key: 'avgPrice', width: 110, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '当月实际收入', dataIndex: 'actualIncome', key: 'actualIncome', width: 130, ellipsis: true, render: v => (v || 0).toFixed(2)},
        {title: '操作', key: 'action', align: 'center', width: 140, fixed: 'right',
            render: (_, r) => (
                <span>
                    {this.hasPerm('400019') ? (<a style={{marginRight: 8}} onClick={() => this.openChannelEdit(r)}>编辑</a>) : null}
                    {this.hasPerm('400020') ? (<a onClick={() => this.delChannel(r)}>删除</a>) : null}
                </span>
            )},
    ]

    render() {
        const yearOptions = [2026, 2027, 2028].map(y => ({value: y, label: y + '年'}));
        const monthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(m => ({value: m, label: m + '月'}));
        const genMonthOptions = monthOptions;
        const statusOptions = [
            {value: 0, label: '未结算'},
            {value: 1, label: '已结算'},
        ];
        const settleAllChecked = this.state.total > 0 && (this.state.selectedRowKeys || []).length >= this.state.total;
        const settleIndeterminate = (this.state.selectedRowKeys || []).length > 0 && !settleAllChecked;
        const settleHeaderSel = {
            checked: settleAllChecked,
            indeterminate: settleIndeterminate,
            onChange: (e) => this.toggleSettleAll(e.target.checked),
        };
        const rowSelection = {
            columnTitle: <Checkbox {...settleHeaderSel} />,
            selectedRowKeys: this.state.selectedRowKeys,
            onChange: (keys, rows, info) => {
                // 表头全选/取消：走跨页 toggleSettleAll，避免 antd 只作用于当前页
                if (info && info.type === 'all') {
                    this.toggleSettleAll(keys.length > 0);
                    return;
                }
                this.setState({selectedRowKeys: keys});
            },
        };
        const rebateSel = this.filteredRebates();
        const pagedRebate = rebateSel.slice((this.state.rebateCurrent - 1) * this.state.rebatePageSize,
            this.state.rebateCurrent * this.state.rebatePageSize);
        const rebateRowSelection = {
            selectedRowKeys: this.state.rebateSelectedKeys,
            onChange: (keys) => this.setState({rebateSelectedKeys: keys}),
        };
        const rebateIds = rebateSel.map(r => r.id);
        const rebateAllChecked = rebateIds.length > 0 && rebateIds.every(id => (this.state.rebateSelectedKeys || []).includes(id));
        const rebateIndeterminate = !rebateAllChecked && rebateIds.some(id => (this.state.rebateSelectedKeys || []).includes(id));
        // 站点结算四个 Tab 的权限码（与生产 menu 表一致）
        const canSettle = this.hasPerm('200014');
        const canRebate = this.hasPerm('200015');
        const canChannel = this.hasPerm('200016');
        const canStat = this.hasPerm('200017');

        const section = this.props.section;
        let body = null;
        if (section === 'stat' && canStat) {
            body = (<>
                            <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '12px'}}>
                                <Select placeholder="年份" allowClear style={{width: 110}}
                                        value={this.state.statYear}
                                        options={yearOptions}
                                        onChange={(v) => this.onStatFilterChange('statYear', v)}/>
                                <Select placeholder="月份" allowClear style={{width: 100}}
                                        value={this.state.statMonth}
                                        options={monthOptions}
                                        onChange={(v) => this.onStatFilterChange('statMonth', v)}/>
                                <Button type="primary" onClick={this.loadStatistics}>查询</Button>
                                <Button onClick={this.resetStatFilter}>重置</Button>
                            </div>
                            <Table rowKey={(_, i) => 'stat' + i} columns={this.statColumns()} dataSource={this.state.statData}
                                   loading={false} size="small" bordered pagination={false} scroll={{x: 1000}}/>
                </>
            );
        } else if (section === 'settle' && canSettle) {
            body = (<>
                            <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '12px'}}>
                                <Select placeholder="年份" allowClear style={{width: 110}}
                                        value={this.state.year}
                                        options={yearOptions}
                                        onChange={(v) => this.onFilterChange('year', v)}/>
                                <Select placeholder="月份" allowClear style={{width: 100}}
                                        value={this.state.month}
                                        options={monthOptions}
                                        onChange={(v) => this.onFilterChange('month', v)}/>
                                <Select placeholder="结算状态" allowClear style={{width: 110}}
                                        value={this.state.status}
                                        options={statusOptions}
                                        onChange={(v) => this.onFilterChange('status', v)}/>
                                <Select placeholder="站点" allowClear showSearch optionFilterProp="label" style={{width: 200}}
                                        value={this.state.siteId}
                                        options={this.state.sites.map(s => ({value: s.id, label: s.siteName}))}
                                        onChange={(v) => this.onFilterChange('siteId', v)}/>
                                <DatePicker.RangePicker placeholder={['结算日期起', '结算日期止']} allowClear format="YYYY-MM-DD"
                                                        value={this.state.settleDateRange}
                                                        onChange={(dates, strs) => this.setState({current: 1, settleDateRange: dates || [], settleDateRangeStr: strs || []}, () => this.initSettle())}/>
                                <span>站点名称：</span>
                                <Input placeholder="请输入站点名称" allowClear style={{width: 180}}
                                       value={this.state.settleSiteQuery}
                                       onChange={(e) => this.setState({settleSiteQuery: e.target.value})}
                                       onPressEnter={this.initSettle}/>
                                <Button type="primary" onClick={this.initSettle}>查询</Button>
                                <Button onClick={this.resetFilter}>重置</Button>
                                {this.hasPerm('400010') ? (<Button onClick={this.openGenerate}>生成结算</Button>) : null}
                                {this.hasPerm('400011') ? (<Button type="primary" onClick={this.openBatch}>批量结算</Button>) : null}
                                <Button onClick={this.initSettle}>刷新</Button>
                                {this.hasPerm('400016') ? (<Button onClick={() => this.exportData(PATH_URL.SITE_SETTLE_EXPORT_SETTLE_URL, this.state.selectedRowKeys)}>导出</Button>) : null}
                            </div>
                            <div style={{fontSize: 13, color: '#606266', marginBottom: '12px'}}>
                                已完成台次 <b style={{color: '#000'}}>{this.state.summary.completedTotal}</b>
                                &nbsp;&nbsp;|&nbsp;&nbsp;需结算金额 <b style={{color: '#000'}}>{(this.state.summary.dueTotal || 0).toFixed(2)}</b>
                                &nbsp;&nbsp;|&nbsp;&nbsp;优惠金额 <b style={{color: '#000'}}>{(this.state.summary.discountTotal || 0).toFixed(2)}</b>
                                &nbsp;&nbsp;|&nbsp;&nbsp;实结算金额 <b style={{color: '#000'}}>{(this.state.summary.settleTotal || 0).toFixed(2)}</b>
                                &nbsp;&nbsp;|&nbsp;&nbsp;未结算金额 <b style={{color: '#000'}}>{(this.state.summary.unSettledTotal || 0).toFixed(2)}</b>
                                &nbsp;&nbsp;|&nbsp;&nbsp;均价 <b style={{color: '#000'}}>{(this.state.summary.completedTotal ? (this.state.summary.settleTotal / this.state.summary.completedTotal).toFixed(2) : '0.00')}</b>
                            </div>
                            <Table rowKey="id" columns={this.settleColumns()} dataSource={this.state.data}
                                   rowSelection={rowSelection} loading={false} size="small" bordered
                                   pagination={false} scroll={{x: 1500}}/>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                                    <Checkbox style={{fontSize: 12}} checked={settleAllChecked} indeterminate={settleIndeterminate}
                                              onChange={(e) => this.toggleSettleAll(e.target.checked)}>全选</Checkbox>
                                    <span style={{fontSize: 12, color: '#606266'}}>已选 <b style={{color: '#1890ff'}}>{(this.state.selectedRowKeys || []).length}</b> 条</span>
                                </div>
                                <Pagination size="small" showSizeChanger current={this.state.current}
                                            pageSize={this.state.pageSize} total={this.state.total}
                                            showTotal={(t) => '共 ' + t + ' 条'}
                                            pageSizeOptions={['10', '20', '50', '100', '200', '500']}
                                            onChange={this.onTableChange}
                                            onShowSizeChange={this.onTableChange}/>
                            </div>
                </>
            );
        } else if (section === 'channel' && canChannel) {
            body = (<>
                            <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px', marginBottom: '12px'}}>
                                <Select placeholder="年份" allowClear style={{width: 110}}
                                        value={this.state.channelYear}
                                        options={yearOptions}
                                        onChange={(v) => this.onChannelFilterChange('channelYear', v)}/>
                                <Select placeholder="月份" allowClear style={{width: 100}}
                                        value={this.state.channelMonth}
                                        options={monthOptions}
                                        onChange={(v) => this.onChannelFilterChange('channelMonth', v)}/>
                                <span>渠道名称：</span>
                                <Input placeholder="请输入渠道名称" allowClear style={{width: 180}}
                                       value={this.state.channelName}
                                       onChange={(e) => this.setState({channelName: e.target.value})}
                                       onPressEnter={this.loadChannels}/>
                                <Button type="primary" onClick={this.loadChannels}>查询</Button>
                                <Button onClick={this.resetChannelFilter}>重置</Button>
                                {this.hasPerm('400018') ? (<Button type="primary" onClick={this.openChannelAdd}>新增</Button>) : null}
                                <Button onClick={this.loadChannels}>刷新</Button>
                            </div>
                            <Table rowKey="id" columns={this.channelColumns()} dataSource={this.state.channelData}
                                   loading={false} size="small" bordered pagination={false} scroll={{x: 1200}}/>
                            <div style={{display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginTop: 8}}>
                                <Pagination size="small" showSizeChanger current={this.state.channelCurrent}
                                            pageSize={this.state.channelPageSize} total={this.state.channelTotal}
                                            showTotal={(t) => '共 ' + t + ' 条'}
                                            onChange={this.onChannelPageChange}
                                            onShowSizeChange={this.onChannelPageChange}/>
                            </div>
                </>
            );
        } else if (section === 'rebate' && canRebate) {
            body = (<>
                            <div style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '8px',
                                        padding: '12px', border: '1px dashed #d9d9d9', borderRadius: '4px', marginBottom: '12px'}}>
                                <span>站点：</span>
                                <Select placeholder="请选择站点" showSearch optionFilterProp="label" style={{width: 260}}
                                        value={this.state.rebateSiteId}
                                        options={this.getRebateSiteOptions().map(s => ({value: s.id, label: s.siteName}))}
                                        onChange={this.handleSiteChange}/>
                                <span>每台返点单价(元)：</span>
                                <InputNumber min={0} precision={2} style={{width: 140}}
                                             value={this.state.rebateAmount}
                                             onChange={(v) => this.setState({rebateAmount: v})}
                                             placeholder="请输入单价"/>
                                {this.hasPerm('400015') ? (
                                    <Button type="primary" onClick={this.saveRebate}>保存</Button>) : null}
                                <Button onClick={this.handleRebateReset}>重置</Button>
                                <Button onClick={this.loadRebates}>刷新</Button>
                                {this.hasPerm('400017') ? (<Button onClick={() => this.exportData(PATH_URL.SITE_SETTLE_EXPORT_REBATE_URL, this.state.rebateSelectedKeys)}>导出</Button>) : null}
                                <span>站点名称：</span>
                                <Input placeholder="请输入站点名称" allowClear style={{width: 180}}
                                       value={this.state.rebateSiteQuery}
                                       onChange={(e) => this.setState({rebateSiteQuery: e.target.value})}
                                       onPressEnter={this.handleRebateQuery}/>
                                <span>状态：</span>
                                <Select placeholder="启用/禁用" allowClear style={{width: 110}}
                                        value={this.state.rebateStatus}
                                        options={[{value: 0, label: '启用'}, {value: 1, label: '禁用'}]}
                                        onChange={(v) => this.setState({rebateStatus: v === undefined || v === null ? null : v, rebateCurrent: 1})}/>
                                <Button type="primary" onClick={this.handleRebateQuery}>查询</Button>
                            </div>
                            <Table rowKey="id" columns={this.rebateColumns()} dataSource={pagedRebate}
                                   rowSelection={rebateRowSelection}
                                   loading={false} size="small" bordered pagination={false} scroll={{x: 800}}/>
                            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 8}}>
                                <Checkbox style={{fontSize: 12}} checked={rebateAllChecked} indeterminate={rebateIndeterminate}
                                          onChange={(e) => this.toggleRebateAll(e.target.checked)}>全选</Checkbox><span style={{marginLeft:8,fontSize:12,color:'#606266'}}>已选 <b style={{color:'#1890ff'}}>{this.state.rebateSelectedKeys.length}</b> 条</span>
                                <Pagination size="small" showSizeChanger current={this.state.rebateCurrent}
                                            pageSize={this.state.rebatePageSize} total={rebateSel.length}
                                            showTotal={(t) => '共 ' + t + ' 条'}
                                            onChange={this.onRebatePageChange}
                                            onShowSizeChange={this.onRebatePageChange}/>
                            </div>
                </>
            );
        }
        if (!body) {
            body = (<div style={{textAlign: 'center', color: '#909399', padding: '60px 0'}}>暂无该模块的访问权限</div>);
        }
        return (
            <>
                {body}

                <Modal title="生成结算" visible={this.state.generateVisible}
                       onOk={this.doGenerate} onCancel={() => this.setState({generateVisible: false})} okText="生成"
                       okButtonProps={{disabled: this.state.generateProcessing}}
                       width={430}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0'}}>
                        <span>统计月份：</span>
                        <Select value={this.state.selYear} style={{width: 120}} options={yearOptions}
                                disabled={this.state.generateProcessing}
                                onChange={(v) => this.setState({selYear: v})}/>
                        <Select value={this.state.selMonth} style={{width: 100}} options={genMonthOptions}
                                disabled={this.state.generateProcessing}
                                onChange={(v) => this.setState({selMonth: v})}/>
                    </div>
                    <div style={{color: '#999', fontSize: '12px'}}>将按所选月份自动统计每家已配置返点的站点已完成台次 × 单价，生成需结算金额。仅支持 2026年1月 及以后。</div>
                    {this.state.generateProcessing || this.state.generateProgress >= 100 ? (
                        <div style={{marginTop: 16}}>
                            <Progress percent={this.state.generateProgress}
                                      status={this.state.generateProgress >= 100 ? 'success' : 'active'}
                                      strokeColor="#2d8cf0"/>
                            <div style={{color: '#666', fontSize: '12px', marginTop: 4}}>
                                {this.state.generateProgress >= 100 ? '生成完成' : '正在生成结算记录，请稍候...'}
                            </div>
                        </div>
                    ) : null}
                </Modal>

                <Modal title="结算" visible={this.state.settleOneVisible}
                       onOk={this.doSettleOne} onCancel={() => this.setState({settleOneVisible: false})} okText="确认结算" width={480}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>需结算金额</span>
                        <InputNumber disabled precision={2} style={{width: 200}}
                                     value={this.state.settleOneDue}/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>优惠金额</span>
                        <InputNumber precision={2} style={{width: 200}}
                                     value={this.state.settleOneDiscount}
                                     onChange={(v) => this.setState({settleOneDiscount: v})}
                                     placeholder="请输入优惠金额"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>实结算金额</span>
                        <InputNumber min={0} precision={2} style={{width: 200}}
                                     value={this.state.settleOneSettle}
                                     onChange={(v) => this.setState({settleOneSettle: v})}
                                     placeholder="请输入实结算金额"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>未结算金额</span>
                        <span style={{fontSize: 14, fontWeight: 700}}>¥ {this.settleOneUnSettled()}</span>
                    </div>
                    <div style={{color: '#999', fontSize: '12px', paddingTop: '6px'}}>未结算金额 = 需结算金额 - 优惠金额 - 实结算金额</div>
                </Modal>

                <Modal title="批量结算" visible={this.state.batchVisible}
                       onOk={this.doBatch} onCancel={() => this.setState({batchVisible: false})} okText="结算" width={480}>
                    <div style={{color: '#666', marginBottom: '8px'}}>已选 <b>{this.state.selectedRowKeys.length}</b> 条记录，请输入本次结算的<b>优惠金额</b>与<b>实结算金额</b>合计（系统将按各条记录的需结算金额占比自动分摊到每一笔，并全部标记为已结算）：</div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>需结算金额</span>
                        <span style={{fontSize: 14, fontWeight: 700}}>¥ {this.state.batchDue.toFixed(2)}</span>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>优惠金额</span>
                        <InputNumber precision={2} style={{width: '100%'}}
                                     value={this.state.batchDiscount}
                                     onChange={(v) => this.setState({batchDiscount: v})}
                                     placeholder="请输入优惠金额"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>实结算金额</span>
                        <InputNumber min={0} precision={2} style={{width: '100%'}}
                                     value={this.state.batchAmount}
                                     onChange={(v) => this.setState({batchAmount: v})}
                                     placeholder="请输入实结算金额"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 120, color: '#606266'}}>未结算金额</span>
                        <span style={{fontSize: 14, fontWeight: 700}}>¥ {this.batchUnSettled()}</span>
                    </div>
                    <div style={{color: '#999', fontSize: '12px', paddingTop: '6px'}}>未结算金额 = 需结算金额 - 优惠金额 - 实结算金额</div>
                </Modal>

                <Modal title="编辑备注" visible={this.state.remarkVisible}
                       onOk={this.saveRemark} onCancel={() => this.setState({remarkVisible: false})} okText="保存" width={460}>
                    <Input.TextArea rows={3} maxLength={500} showCount
                                    value={this.state.remarkText}
                                    onChange={(e) => this.setState({remarkText: e.target.value})}
                                    placeholder="请输入备注内容"/>
                </Modal>

                <Modal title={'结算特殊说明：' + this.state.siteRemarkSiteName} visible={this.state.siteRemarkVisible}
                       onOk={this.saveSiteRemark} onCancel={() => this.setState({siteRemarkVisible: false})} okText="保存" width={480}>
                    <Input.TextArea rows={4} maxLength={500} showCount
                                    value={this.state.siteRemarkText}
                                    onChange={(e) => this.setState({siteRemarkText: e.target.value})}
                                    placeholder="请输入结算特殊说明"/>
                </Modal>

                <Modal title={'编辑返点设置：' + this.state.rebateEditSiteName} visible={this.state.rebateEditVisible}
                       onOk={this.saveRebateEdit} onCancel={() => this.setState({rebateEditVisible: false})} okText="保存" width={480}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>每台返点单价(元)</span>
                        <InputNumber min={0} precision={2} style={{flex: 1}}
                                     value={this.state.rebateEditAmount}
                                     onChange={(v) => this.setState({rebateEditAmount: v})}
                                     placeholder="请输入每台返点单价"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'flex-start', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>结算特殊说明</span>
                        <Input.TextArea rows={4} maxLength={500} showCount style={{flex: 1}}
                                        value={this.state.rebateEditSiteRemark}
                                        onChange={(e) => this.setState({rebateEditSiteRemark: e.target.value})}
                                        placeholder="请输入结算特殊说明"/>
                    </div>
                </Modal>

                <Modal title={this.state.channelEditId != null ? '编辑特殊渠道' : '新增特殊渠道'} visible={this.state.channelAddVisible}
                       onOk={this.doChannelAdd} onCancel={() => this.setState({channelAddVisible: false})} okText="保存" width={520}>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>年/月</span>
                        <Select value={this.state.addChannelYear} style={{width: 110}} options={yearOptions}
                                onChange={(v) => this.setState({addChannelYear: v})}/>
                        <Select value={this.state.addChannelMonth} style={{width: 100}} options={monthOptions}
                                onChange={(v) => this.setState({addChannelMonth: v})}/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>渠道名称</span>
                        <Input style={{flex: 1}} maxLength={100} placeholder="请输入渠道名称"
                               value={this.state.addChannelName}
                               onChange={(e) => this.setState({addChannelName: e.target.value})}/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>单台提成金额</span>
                        <InputNumber min={0} precision={2} style={{width: '100%'}}
                                     value={this.state.addPerCommission}
                                     onChange={(v) => this.setState({addPerCommission: v})}
                                     placeholder="请输入单台提成金额"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>当月总台次</span>
                        <InputNumber min={0} precision={0} style={{width: '100%'}}
                                     value={this.state.addTotalCount}
                                     onChange={(v) => this.setState({addTotalCount: v})}
                                     placeholder="请输入当月总台次"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>当月结算总金额</span>
                        <InputNumber min={0} precision={2} style={{width: '100%'}}
                                     value={this.state.addTotalSettle}
                                     onChange={(v) => this.setState({addTotalSettle: v})}
                                     placeholder="请输入当月结算总金额"/>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>当月提成</span>
                        <span style={{fontSize: 14, fontWeight: 700}}>¥ {this.addMonthlyCommission()}</span>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>当月均价</span>
                        <span style={{fontSize: 14, fontWeight: 700}}>¥ {this.addAvgPrice()}</span>
                    </div>
                    <div style={{display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 0'}}>
                        <span style={{width: 130, color: '#606266'}}>当月实际收入</span>
                        <span style={{fontSize: 14, fontWeight: 700}}>¥ {this.addActualIncome()}</span>
                    </div>
                    <div style={{color: '#999', fontSize: '12px', paddingTop: '6px'}}>当月均价 = 当月结算总金额 ÷ 当月总台次；当月提成 = 当月总台次 × 单台提成金额；当月实际收入 = 当月总台次 × (当月均价 - 单台提成金额)</div>
                </Modal>
            </>
        )
    }
}

export default SiteSettleManageInfo;